define(
    'viewmodels/secured/explorer/details/tabs/actions/UndeleteAction',[
        "viewmodels/secured/explorer/context",
        "viewmodels/secured/explorer/details/tabs/actions/Action",
        "viewmodels/secured/explorer/details/documentClipboard",
        "services/config",
        "services/eventbroker",
        "services/service.dialog",
        "services/service.documents",
        "i19n!i19n/strings"
    ],
    function (ctx, Action, documentClipboard, config, eventBroker, dialogService, documentsService, i19n) {

        var UnDeleteAction = (function (_super) {

            var _i19n = {
                action: {
                    name: i19n.to.undelete,
                    message: i19n.to.undeletetheselecteddocument + "."
                }
            };

            __extends(Action, _super);

            function _Action(context, disableFilters, hideFilters) {
                _super.call(this, _i19n.action, "fa-undo", context, disableFilters, hideFilters);

                this.command = Action.getCommand(this, { execute: execute });
            }

            function execute(action, complete) {
                var documents = action.context.checkedDocuments();

                documentsService.actions.canDelete(documents)
                .done(function (result) {
                    var promise;

                    if (!result.success) {
                        promise = dialogService.showDocumentActionErrorDialog(result);
                    } else {
                        var folderId = documents[0].folderId;
                        var libraryId = documents[0].libraryId

                        promise = dialogService.showDialog("modals/secured/explorer/details/tabs/actions/DocumentActionUnDeleteModal", '');
                        
                        var ids = _.map(documents, function (itm) { return { folderId: itm.folderId, libraryId: itm.libraryId}; });
                        ids = _.groupBy(ids, function (itm) { return itm.folderId});

                        //console.warn(ids);
                        //console.warn(ids["f5c81595-f601-4ff4-baa0-19785d24c2ba"].length);
                        //ids = _.uniq(ids, function (itm) { return itm.folderId; });
                        
                        promise.then(function (dialogResult) {
                            if (dialogResult.undeleting) {
                                documentsService.actions.undeleteDocuments(documentClipboard.toDocumentLocationList(documents))
                                .done(function () {
                                })
                                .fail(function (e) {
                                    e.stopPropagation = true;

                                    self.errors(e.error);

                                    console.warn(e);
                                })
                                .always(function () {
                                    
                                    ctx.onReloadResults(null);

                                    complete();
                                });
                            } else {
                                complete();
                            }
                        });
                    }

                    promise.then(complete);
                });
            }

            return _Action;

        })(Action);

        return UnDeleteAction;
        
    });
